import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private http: HttpClient) { }

  checkSurvey(token){
    return this.http.get(`${environment.apiUrl}api/Tickets/CheckSurvey/${token}`)
  }
  postSurvey(obj){
    return this.http.post(`${environment.apiUrl}api/Tickets/AddTicketSurvey`,obj)
  }
}
